export const MESSAGES_PER_FETCH = 20;
